
(() => {
  function initializeDulceFallback() {
    if (!document.getElementById('dulce-fallback-styles')) {
      const style = document.createElement('style');
      style.id = 'dulce-fallback-styles';
      style.textContent = `
        media-gallery.dulce-fallback-active > [id^="GalleryViewer"],
        media-gallery.dulce-fallback-active > [id^="GalleryThumbnails"],
        media-gallery.dulce-fallback-active > [data-shopify-xr] {
          display: none !important;
        }

        .dulce-fallback-preview {
          width: 100%;
          box-sizing: border-box;
          background: #fff;
        }

        .dulce-fallback-preview img {
          display: block;
          width: 100%;
          height: auto;
          aspect-ratio: 1 / 1;
          object-fit: contain;
          background: #f7f7f7;
        }

        .dulce-fallback-preview p {
          margin: 10px 12px 4px;
          font-size: 13px;
          line-height: 1.5;
          text-align: center;
          color: #333;
        }

        .dulce-fallback-preview button {
          display: block;
          margin: 8px auto 16px;
          padding: 8px;
          border: 0;
          background: transparent;
          color: #333;
          text-decoration: underline;
          cursor: pointer;
          font-size: 13px;
        }
      `;
      document.head.appendChild(style);
    }

    document.querySelectorAll(
      'variant-radios[data-section], variant-selects[data-section]'
    ).forEach((picker) => {
      if (picker.dataset.dulceFallbackReady === 'true') return;

      const sectionId = picker.dataset.section;
      const dataElement = document.getElementById(
        `DulceFallbackData-${sectionId}`
      );

      if (!dataElement) return;

      let data;
      try {
        data = JSON.parse(dataElement.textContent);
      } catch (error) {
        console.warn('Dulce fallback data error:', error);
        return;
      }

      picker.dataset.dulceFallbackReady = 'true';

      const galleries = [
        document.getElementById(`MediaGallery-${sectionId}`),
        document.getElementById(`MediaGallery-${sectionId}-right`)
      ].filter(Boolean);

      function normalizeColor(color) {
        return String(color || '')
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
      }

      function clearFallback() {
        galleries.forEach((gallery) => {
          gallery.classList.remove('dulce-fallback-active');

          gallery.querySelectorAll('.dulce-fallback-preview')
            .forEach((preview) => preview.remove());
        });
      }

      function showFallback(gallery, imageUrl, color) {
        const viewer = gallery.querySelector(
          '[id^="GalleryViewer"]'
        );

        if (!viewer) return;

        const preview = document.createElement('div');
        preview.className = 'dulce-fallback-preview';

        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = `${color} blank garment color reference`;

        image.addEventListener('error', () => {
          console.warn('Dulce fallback image failed:', imageUrl);
          clearFallback();
        });

        const notice = document.createElement('p');
        notice.textContent =
          'Color reference only — blank garment shown. ' +
          'The finished product includes the design pictured in the listing.';

        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = 'View product design photos';
        button.addEventListener('click', clearFallback);

        preview.append(image, notice, button);

        gallery.insertBefore(preview, viewer);
        gallery.classList.add('dulce-fallback-active');
      }

      function updateFallback() {
        clearFallback();

        const variant = picker.currentVariant;

        if (!variant || variant.featured_media) return;
        if (data.colorOptionIndex < 0) return;

        const color = variant.options[data.colorOptionIndex];
        const imageUrl = data.images?.[normalizeColor(color)];

        if (!imageUrl) return;

        galleries.forEach((gallery) => {
          showFallback(gallery, imageUrl, color);
        });
      }

      picker.addEventListener('change', () => {
        requestAnimationFrame(updateFallback);
      });

      galleries.forEach((gallery) => {
        const viewer = gallery.querySelector(
          '[id^="GalleryViewer"]'
        );

        if (viewer) {
          viewer.addEventListener('slideChanged', clearFallback);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeDulceFallback
    );
  } else {
    initializeDulceFallback();
  }
})();
